import React from "react";
import ModalButton from "../ModalButton";
import { CircleIcon, XIcon } from "@phosphor-icons/react";
import {
  StyledPopup,
  HeadCard,
  Content,
  IconWrap,
  TitleGroup,
  Title,
  Intro,
  RequirementsList,
  RequirementRow,
  RequirementIcon,
  CircleBox,
  CheckBox,
  RequirementBody,
  RequirementLabel,
  RequirementDescription,
  RequirementAction,
  BottomCard,
} from "./styles";
import { WarningCircleIcon } from "@phosphor-icons/react";

export type Requirement = {
  label: string;
  met: boolean;
  description?: string;
  actionLabel?: string;
  actionUrl?: string;
};

type Props = {
  open: boolean;
  color: string;
  title: string;
  intro: string;
  requirements: Requirement[];
  actionLabel: string;
  onClose: () => void;
  onAction: () => void;
};

const MarcaBlancaRequirementsModal: React.FC<Props> = ({
  open,
  color,
  title,
  intro,
  requirements,
  actionLabel,
  onClose,
  onAction,
}) => {
  return (
    <StyledPopup
      open={open}
      modal
      closeOnDocumentClick={false}
      closeOnEscape={false}
      onClose={() => undefined}
    >
      <div className="container">
        <HeadCard>
          <XIcon
            size={24}
            color="#999999"
            style={{ cursor: "pointer" }}
            onClick={onClose}
          />
        </HeadCard>

        <Content>
          <IconWrap>
            <WarningCircleIcon size={50} weight="regular" color="#F5C518" />
          </IconWrap>

          <TitleGroup>
            <Title>{title}</Title>
            <Intro>{intro}</Intro>
          </TitleGroup>

          <RequirementsList>
            {requirements.map((req, index) => (
              <RequirementRow key={index}>
                <RequirementIcon>
                  {req.met ? (
                    <CheckBox>
                      <svg
                        width="11.3"
                        height="8.7"
                        viewBox="0 0 11.3 8.7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.75 4.6L4.2 7.95L10.55 0.75"
                          stroke="#67c940"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </CheckBox>
                  ) : (
                    <CircleBox>
                      <CircleIcon size={24} weight="regular" color="#F5C518" />
                    </CircleBox>
                  )}
                </RequirementIcon>
                <RequirementBody>
                  <RequirementLabel>{req.label}</RequirementLabel>
                  {!req.met && req.description && (
                    <RequirementDescription>
                      {req.description}
                    </RequirementDescription>
                  )}
                </RequirementBody>
                {!req.met && req.actionLabel && req.actionUrl && (
                  <RequirementAction
                    href={req.actionUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {req.actionLabel}
                  </RequirementAction>
                )}
              </RequirementRow>
            ))}
          </RequirementsList>
        </Content>

        <BottomCard>
          <ModalButton color={color} secondary={false} onClick={onAction}>
            {actionLabel}
          </ModalButton>
        </BottomCard>
      </div>
    </StyledPopup>
  );
};

export default MarcaBlancaRequirementsModal;
